const S3_BASE_URL = 'https://vendor-category-specific-images.s3.us-east-1.amazonaws.com';

const defaultImagesByCategory = {
    Lodging: [
        `${S3_BASE_URL}/Lodging/Lodging1.jpg`,
        `${S3_BASE_URL}/Lodging/Lodging2.jpg`,
        `${S3_BASE_URL}/Lodging/Lodging3.jpg`,
        `${S3_BASE_URL}/Lodging/Lodging4.png`,
        `${S3_BASE_URL}/Lodging/Lodging5.png`,
    ],
    Venue: [
        `${S3_BASE_URL}/Venue/Venue1.jpg`,
        `${S3_BASE_URL}/Venue/Venue2.jpg`,
        `${S3_BASE_URL}/Venue/Venue3.jpg`,
        `${S3_BASE_URL}/Venue/Venue4.png`,
        `${S3_BASE_URL}/Venue/Venue5.png`,
        `${S3_BASE_URL}/Venue/Venue6.png`,
    ],
    Officiant: [
        `${S3_BASE_URL}/Officiant/Officiant1.jpg`,
        `${S3_BASE_URL}/Officiant/Officiant2.jpg`,
        `${S3_BASE_URL}/Officiant/Officiant3.jpg`,
        `${S3_BASE_URL}/Officiant/Officiant4.png`,
        `${S3_BASE_URL}/Officiant/Officiant5.png`,
        `${S3_BASE_URL}/Officiant/Officiant6.jpg`,
        `${S3_BASE_URL}/Officiant/Officiant7.png`,
    ],
    Photography: [
        `${S3_BASE_URL}/Photography/Photography1.jpg`,
        `${S3_BASE_URL}/Photography/Photography2.jpg`,
        `${S3_BASE_URL}/Photography/Photography3.jpg`,
        `${S3_BASE_URL}/Photography/Photography4.png`,
        `${S3_BASE_URL}/Photography/Photography5.jpg`,
    ],
    Videography: [
        `${S3_BASE_URL}/Videography/Videography1.jpg`,
        `${S3_BASE_URL}/Videography/Videography2.jpg`,
        `${S3_BASE_URL}/Videography/Videography3.jpg`,
        `${S3_BASE_URL}/Videography/Videography4.png`,
    ],
    'Wedding Planner': [
        `${S3_BASE_URL}/Wedding+Planner/WeddingPlanner1.jpg`,
        `${S3_BASE_URL}/Wedding+Planner/WeddingPlanner2.jpg`,
        `${S3_BASE_URL}/Wedding+Planner/WeddingPlanner3.jpg`,
        `${S3_BASE_URL}/Wedding+Planner/WeddingPlanner4.png`,
        `${S3_BASE_URL}/Wedding+Planner/WeddingPlanner5.png`,
        `${S3_BASE_URL}/Wedding+Planner/WeddingPlanner6.png`,
        `${S3_BASE_URL}/Wedding+Planner/WeddingPlanner7.png`,
    ],
    'Wedding Cake': [
        `${S3_BASE_URL}/Wedding+Cake/WeddingCake1.jpg`,
        `${S3_BASE_URL}/Wedding+Cake/WeddingCake2.jpg`,
        `${S3_BASE_URL}/Wedding+Cake/WeddingCake3.jpg`,
        `${S3_BASE_URL}/Wedding+Cake/WeddingCake4.png`,
        `${S3_BASE_URL}/Wedding+Cake/WeddingCake5.png`,
        `${S3_BASE_URL}/Wedding+Cake/WeddingCake6.png`,
        `${S3_BASE_URL}/Wedding+Cake/WeddingCake7.png`,
    ],
    Transportation: [
        `${S3_BASE_URL}/Transportation/Transportation1.jpg`,
        `${S3_BASE_URL}/Transportation/Transportation2.jpg`,
        `${S3_BASE_URL}/Transportation/Transportation3.jpg`,
        `${S3_BASE_URL}/Transportation/Transportation4.png`,
        `${S3_BASE_URL}/Transportation/Transportation5.png`,
        `${S3_BASE_URL}/Transportation/Transportation6.png`,
    ],
    'Rental & Equipment': [
        `${S3_BASE_URL}/Rental+&+Equipment/Rental1.jpg`,
        `${S3_BASE_URL}/Rental+&+Equipment/Rental2.jpg`,
        `${S3_BASE_URL}/Rental+&+Equipment/Rental3.jpg`,
        `${S3_BASE_URL}/Rental+&+Equipment/Rental4.jpg`,
        `${S3_BASE_URL}/Rental+&+Equipment/Rental5.jpg`,
    ],
    Tuxedo: [
        `${S3_BASE_URL}/Tuxedo/Tuxedo1.jpg`,
        `${S3_BASE_URL}/Tuxedo/Tuxedo2.jpg`,
        `${S3_BASE_URL}/Tuxedo/Tuxedo3.jpg`,
        `${S3_BASE_URL}/Tuxedo/Tuxedo4.png`,
        `${S3_BASE_URL}/Tuxedo/Tuxedo5.png`,
        `${S3_BASE_URL}/Tuxedo/Tuxedo6.png`,
    ],
    Photobooth: [
        `${S3_BASE_URL}/Photobooth/Photobooth1.jpeg`,
        `${S3_BASE_URL}/Photobooth/Photobooth2.jpg`,
        `${S3_BASE_URL}/Photobooth/Photobooth3.jpg`,
        `${S3_BASE_URL}/Photobooth/Photobooth4.png`,
        `${S3_BASE_URL}/Photobooth/Photobooth5.png`,
    ],
    'Other Service': [
        `${S3_BASE_URL}/Other-Service/other1.jpg`,
        `${S3_BASE_URL}/Other-Service/other2.jpg`,
        `${S3_BASE_URL}/Other-Service/other3.jpg`,
    ],
    'Band & DJ': [
        `${S3_BASE_URL}/Band&DJ/Band&DJ1.png`,
        `${S3_BASE_URL}/Band&DJ/Band&DJ2.png`,
        `${S3_BASE_URL}/Band&DJ/Band&DJ3.png`,
        `${S3_BASE_URL}/Band&DJ/Band&DJ4.png`,
        `${S3_BASE_URL}/Band&DJ/Band&DJ5.png`,
        `${S3_BASE_URL}/Band&DJ/Band&DJ6.png`,
        `${S3_BASE_URL}/Band&DJ/Band&DJ7.png`,
        `${S3_BASE_URL}/Band&DJ/Band&DJ8.png`,
    ],
    'Beauty Salon': [
        `${S3_BASE_URL}/Beauty-Salon/Beauty1.png`,
        `${S3_BASE_URL}/Beauty-Salon/Beauty2.png`,
        `${S3_BASE_URL}/Beauty-Salon/Beauty3.png`,
        `${S3_BASE_URL}/Beauty-Salon/Beauty4.png`,
        `${S3_BASE_URL}/Beauty-Salon/Beauty5.png`,
        `${S3_BASE_URL}/Beauty-Salon/Beauty6.png`,
    ],
    'Catering & Bar': [
        `${S3_BASE_URL}/Catering&Bar/Catering1.png`,
        `${S3_BASE_URL}/Catering&Bar/Catering2.png`,
        `${S3_BASE_URL}/Catering&Bar/Catering3.png`,
        `${S3_BASE_URL}/Catering&Bar/Catering4.png`,
    ],
    Dress: [
        `${S3_BASE_URL}/Dresses/Dress1.png`,
        `${S3_BASE_URL}/Dresses/Dress2.jpg`,
        `${S3_BASE_URL}/Dresses/Dress3.jpg`,
    ],
    'Entertainment Service': [
        `${S3_BASE_URL}/Entertainment-services/Entertainment-services1.png`,
        `${S3_BASE_URL}/Entertainment-services/Entertainment-services2.png`,
        `${S3_BASE_URL}/Entertainment-services/Entertainment-services3.png`,
    ],
    'Favor & Gift': [
        `${S3_BASE_URL}/Favors&Gifts/Favors&Gifts1.png`,
        `${S3_BASE_URL}/Favors&Gifts/Favors&Gifts2.png`,
        `${S3_BASE_URL}/Favors&Gifts/Favors&Gifts3.png`,
        `${S3_BASE_URL}/Favors&Gifts/Favors&Gifts4.png`,
        `${S3_BASE_URL}/Favors&Gifts/Favors&Gifts5.png`,
        `${S3_BASE_URL}/Favors&Gifts/Favors&Gifts6.png`,
        `${S3_BASE_URL}/Favors&Gifts/Favors&Gifts7.png`,
    ],
    Florist: [
        `${S3_BASE_URL}/Florists/Florists1.png`,
        `${S3_BASE_URL}/Florists/Florists2.png`,
        `${S3_BASE_URL}/Florists/Florists3.png`,
        `${S3_BASE_URL}/Florists/Florists4.png`,
        `${S3_BASE_URL}/Florists/Florists5.png`,
    ],
    'Health & Wellness': [
        `${S3_BASE_URL}/Health&Wellness/Health&Wellness1.png`,
        `${S3_BASE_URL}/Health&Wellness/Health&Wellness2.png`,
        `${S3_BASE_URL}/Health&Wellness/Health&Wellness3.png`,
        `${S3_BASE_URL}/Health&Wellness/Health&Wellness4.png`,
    ],
    Home: [
        `${S3_BASE_URL}/Home/Home1.png`,
        `${S3_BASE_URL}/Home/Home2.png`,
        `${S3_BASE_URL}/Home/Home3.png`,
        `${S3_BASE_URL}/Home/Home4.png`,
        `${S3_BASE_URL}/Home/Home5.png`,
        `${S3_BASE_URL}/Home/Home6.png`,
    ],
    Jewelry: [
        `${S3_BASE_URL}/Jewelery/Jewelery1.png`,
        `${S3_BASE_URL}/Jewelery/Jewelery2.png`,
        `${S3_BASE_URL}/Jewelery/Jewelery3.png`,
    ],
    'Invitation & Stationery': [`${S3_BASE_URL}/Invites&Stationary/Invites&Stationary.png`],
};

export default defaultImagesByCategory;
